export default __webpack_public_path__ + "static/media/down-arrow.d3bad938.svg";